import { BuildingTheme } from './types';
import { createAsyncAction } from 'typesafe-actions';

export const getBuildingTheme = createAsyncAction(
  'GET_BUILDING_THEME_REQUEST',
  'GET_BUILDING_THEME_SUCCESS',
  'GET_BUILDING_THEME_FAILURE',
)<string, BuildingTheme, Error>();
